import * as React from "react";
function TransportTaxiTypeExecElectric() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 160 160"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "usbms9m9cndalha",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,120 H 120 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "usbms9m9cndalib",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77.3358,93.9372 H 115.037 V 56.2356 H 77.3358 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "usbms9m9cndaljc",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.68471,43.9874 H 111.574 V 24.9198 H 6.68471 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usbms9m9cndalha)",
    transform: "matrix(1.33333 0 0 -1.33333 0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usbms9m9cndalib)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575859",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,10.411 -8.44,18.851 -18.851,18.851 -10.411,0 -18.851,-8.44 -18.851,-18.851 0,-10.411 8.44,-18.851 18.851,-18.851 C -8.44,-18.851 0,-10.411 0,0",
    transform: "translate(115.037 75.086)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,-0.815 8.328,19.348 8.328,19.348 l -13.622,0.306 c 0,0 9.063,15.37 9.063,16.728 h 7.06 L 2.251,24.188 15.291,23.147 Z",
    transform: "translate(90.908 52.904)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usbms9m9cndaljc)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636566",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -0.154,-5.194 -23.759,-8.706 -52.723,-7.845 -28.964,0.861 -52.319,5.769 -52.165,10.963 0.154,5.193 23.759,8.706 52.723,7.845 C -23.201,10.102 0.154,5.194 0,0",
    transform: "translate(111.573 32.895)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -2.251,-0.973 -5.78,-2.19 -6.51,-4.928 -0.73,-2.737 -0.923,-9.406 0.36,-10.573 l 7.671,-0.195 z",
    transform: "translate(15.444 54.914)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -2.251,-0.973 -8.152,-5.962 -8.882,-8.7 -0.73,-2.737 -0.923,-9.405 0.36,-10.573 l 7.062,-0.377 z",
    transform: "translate(63.81 54.002)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0.305,-0.672 2.137,-3.663 4.335,-4.335 2.197,-0.671 5.982,-0.305 7.448,0.611 1.465,0.916 2.747,1.648 3.724,4.151 C 16.483,2.93 17.888,8.608 14.53,11.294 11.172,13.98 2.93,15.446 2.076,14.469 1.221,13.492 0,0 0,0",
    transform: "translate(94.825 36.391)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 C -1.097,-0.629 -2.316,-1.158 -3.298,-3.053 -4.281,-4.947 -4.772,-8.421 -4.702,-10 c 0.07,-1.579 0.597,-4.702 1.93,-6.807 1.333,-2.105 2.491,-3.088 4.176,-3.333 1.684,-0.246 5.918,0.108 6.655,0.283 0.737,0.175 1.754,0.807 2.246,1.403 0.491,0.597 1.579,1.79 2.175,4.527 0.597,2.737 0.741,7.305 -2.137,12.393 C 8.847,1.111 2.386,1.368 0,0",
    transform: "translate(60.306 50.074)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,-2.609 -0.951,-4.716 -2.125,-4.706 -1.174,0.009 -2.125,2.132 -2.125,4.741 0,2.609 0.951,4.716 2.125,4.707 C -0.951,4.732 0,2.609 0,0",
    transform: "translate(63.179 40.295)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -0.955,-0.548 -2.015,-1.007 -2.869,-2.656 -0.855,-1.648 -1.282,-4.67 -1.221,-6.044 0.061,-1.373 0.519,-4.09 1.679,-5.921 1.159,-1.832 2.167,-2.687 3.632,-2.9 1.465,-0.214 4.487,0 5.128,0.152 0.641,0.153 1.526,0.702 1.954,1.221 0.427,0.519 1.373,1.557 1.892,3.938 0.519,2.381 0.855,6.349 -1.648,10.775 C 7.246,0.867 2.076,1.19 0,0",
    transform: "translate(13.506 51.531)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f4f4f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0.901,6.825 4.533,6.244 7.752,7.661 2.699,1.187 5.824,4.542 10.715,6.522 10.046,4.066 29.926,2.696 42.757,2.199 9.777,-0.379 22.809,-9.946 26.166,-13.229 0,0 0.243,0.036 2.823,-0.918 1.743,-0.644 5.153,-1.806 5.588,-1.846 0.436,-0.039 1.442,0 3.321,-0.889 6.989,-3.309 6.467,-10.405 6.254,-15.557 0.08,-0.436 0.186,-1.409 0.159,-1.782 -0.093,-1.256 -7.691,-3.04 -18.265,-3.401 -1.919,-0.065 -16.935,10e-4 -22.308,0.071 -1.202,0.016 -2.231,0.849 -2.512,2.018 -0.77,3.203 -1.34,8.18 -2.083,10.469 -2.224,6.851 -11.336,5.021 -12.025,-2.658 -0.443,-4.937 0.19,-6.962 0.76,-8.924 -8.111,0.413 -26.201,1.772 -34.681,2.785 -0.622,0.074 -1.794,0.788 -2.032,1.976 -1.037,4.92 0.98,11.826 -4.971,12.638 -6.035,-0.691 -6.09,-8.533 -4.992,-13.156 -0.115,0 -0.395,0.326 -0.795,0.568 -0.996,0.602 -1.672,2.064 -2.006,3.179 -0.446,1.485 -0.604,3.208 -0.552,4.653 0.014,0.404 0.075,0.806 0.214,1.185 C -0.078,-4.704 -0.039,-0.879 0,0",
    transform: "translate(7.712 54.73)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -1.987,0.916 -0.997,2.014 -0.388,2.505 1.763,1.42 5.557,4.569 11.316,5.519 4.124,0.68 9.5,0.517 13.233,-2.452 4.04,-3.214 7.504,-8.021 7.981,-8.873 C 30.347,-3.563 5.104,-2.354 0,0",
    transform: "translate(21.448 61.123)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,0 5.038,-2.652 9.018,-6.391 2.785,-2.616 5.704,-5.093 6.075,-5.316 0.372,-0.223 8.69,-0.604 12.49,-0.527 7.066,0.143 18.842,0.647 18.056,0.591 0,0 -4.206,3.106 -9.822,6.525 -5.045,3.071 -6.499,3.573 -10.516,4.391 C 21.284,0.091 0,0 0,0",
    transform: "translate(45.642 69.492)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -2.407,0.49 -11.01,0.654 -17.522,0.706 1.655,-1.096 3.637,-2.544 5.412,-4.212 2.785,-2.615 5.704,-5.092 6.075,-5.315 0.372,-0.223 8.69,-0.604 12.49,-0.527 3.29,0.066 7.592,0.211 11.181,0.341 -1.76,1.211 -4.254,2.871 -7.12,4.616 C 5.471,-1.32 4.017,-0.818 0,0",
    transform: "translate(66.77 66.606)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 1.069,-3.131 5.002,-5.957 5.511,-6.086 1.481,-0.375 5.885,-0.869 8.191,-0.645 0.815,0.078 3.201,0.314 3.568,0.682 C 15.36,-5.068 9.214,-2.077 3.05,-0.521 0.769,0.055 0,0 0,0",
    transform: "translate(69.01 54.458)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 C 0.581,-0.484 1.327,-0.751 2.069,-2.031 2.8,-3.293 2.803,-4.805 3.263,-5.1 c 0.46,-0.295 2.077,-0.094 2.452,0.031 0.794,0.265 0.415,0.99 0.415,0.99 0,0 -0.713,1.754 -1.945,2.605 C 3.404,-0.935 0.477,0.043 0,0",
    transform: "translate(103.862 53.558)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 1.894,-0.091 9.134,-0.187 13.853,0.413 0.524,0.067 1.211,-0.139 1.532,-0.559 0.153,-0.199 0.279,-0.448 0.322,-0.753 0.138,-0.975 0.414,-2.863 0.414,-2.863 0,0 -5.112,-1.001 -8.775,-1.062 -3.662,-0.06 -9.033,-0.211 -11.298,0.118 0.171,0.735 0.438,3.028 0.734,3.615 C -2.627,0.078 -1.342,0.064 0,0",
    transform: "translate(92.952 43.873)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,-2.386 -0.764,-4.32 -1.705,-4.32 -0.942,0 -1.706,1.934 -1.706,4.32 0,2.386 0.764,4.32 1.706,4.32 C -0.764,4.32 0,2.386 0,0",
    transform: "translate(15.249 42.98)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f4f4f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -0.437,-0.677 -0.858,-1.178 -2.138,-3.959 -2.127,-4.62 -2.171,-7.418 -2.171,-7.418 l 3.577,-0.484 c 0,0 0.494,2.809 0.96,4.361 0.467,1.553 1.925,5.799 3.321,7.495 z",
    transform: "translate(35.151 70.015)"
  })));
}
export default TransportTaxiTypeExecElectric;